export default __webpack_public_path__ + "open-modal-icon.9f0bc153d8e720deaa63.png";